import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './QuizeStart.css'
const QuizzesStart = () => {
    const quizzes = useLoaderData().data;
    const { name, questions } = quizzes;
    console.log(questions)
    const notify = (coorectAns) => {
        toast(coorectAns)
    }
    const [questionId , setQuestionID] = useState([])
    const quizeTextFunct = (text, answer, id) => {
        if (text === answer) {
            toast('Correct Answer');
            setQuestionID(id)
        }
        else {
            toast('Incorrect Answer')
            setQuestionID(id)
        }
    }
    let questionCount = 1;
    return (
        <div>
            <div className='w-75 mx-auto mt-3'>
                <div className="row">
                    <h1 className='text-center mb-5'>Quize of {name}</h1>
                    <div className="col-sm-9">
                        {
                            questions.map((question, index) => <div className='shadow p-3 mb-5 rounded' key={index}>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <b className='d-block mb-3 fs-5'>{`${questionCount++}. `+ question.question.replace(/(<([^>]+)>)/ig,'')}</b>
                                    <FontAwesomeIcon onClick={() => notify(question.correctAnswer)} className='btn' icon={faEye}></FontAwesomeIcon>
                                    <ToastContainer />
                                </div>
                                <div className='border border-1 p-3 mb-2'>
                                    {
                                        question.options.map((option, index) => <p onClick={() => quizeTextFunct(option, question.correctAnswer, question.id)} key={index} className='my-class p-2 rounded border border-1'>
                                            {option}
                                        </p>
                                        )
                                    }
                                </div>
                            </div>
                            )
                        }
                    </div>

                    <div className="col-sm-3 border border-1 text-center p-3 rounded position-sticky top-0 vh-100">
                        <p className='fw-bold text-decoration-underline fs-3'>Quize Summary</p>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default QuizzesStart;